module.exports = __webpack_public_path__ + "static/media/carry02.1fa4f13b.png";